'use client'

import { faPlayCircle } from '@fortawesome/free-regular-svg-icons'
import { useCachedCourseUnitTimeProgressSWR } from '~/app/actions/progress'
import OverviewStatusChip from '~/components/progress/OverviewStatusChip'
import { SupportedLocales } from '~/types'

export default function ModuleOverviewDoneTime({
  courseId,
  moduleId,
  locale,
  totalMinutes,
}: {
  courseId: string | number
  moduleId: string | number
  locale: SupportedLocales
  totalMinutes: number
}) {
  const { data } = useCachedCourseUnitTimeProgressSWR({
    courseId,
    locale,
  })

  const completedMinutes = data?.moduleCompletedMinutes?.[Number(moduleId)] ?? 0

  return (
    <OverviewStatusChip
      icon={faPlayCircle}
      kind="time"
      completed={completedMinutes}
      total={totalMinutes}
      showWhenZero
      label={`${completedMinutes} / ${totalMinutes} min`}
    />
  )
}
